const ROLE_TYPES = ['admin', 'owner', 'general manager', 'sales manager', 'salesperson', 'finance manager', 'finance', 'service manager', 'technician', 'manager', 'collector', 'accountant', 'comptroller', 'clerical', 'other']

module.exports = {
    ROLE_TYPES
}